import FormStep, {
    MembershipWizardForm
} from 'web/screen/MembershipApplication/FormStep/FormStep';
import { computed, observable } from 'mobx';
import { Form, FormField, RequiredFieldValidator } from 'react-mvvm/forms';
import BirthDatePicker from 'common/components/BirthDatePicker/BirthDatePicker';
import { MembershipApplicationDto } from 'model/Api/Members/Model/MembershipApplicationDto';

class StudentForm implements MembershipWizardForm {
    parent: FormStep;
    @observable formValues: Partial<MembershipApplicationDto> = {};
    @observable form: Form<any>;

    constructor(parent: FormStep) {
        this.parent = parent;
        this.form = this.buildMembershipForm();
    }

    @computed get userAddresses() {
        return this.parent.userAddresses;
    }

    @computed get application() {
        return this.parent.application;
    }

    buildMembershipForm = () => {
        return new Form({
            birthDate: new BirthDatePicker(
                this.parent.parent.initApplication?.birthDate,
                RequiredFieldValidator
            ),
            gender: new FormField(
                this.parent.parent.initApplication?.gender,
                RequiredFieldValidator
            ),
            schoolName: new FormField(
                this.parent.parent.initApplication?.schoolName,
                RequiredFieldValidator
            ),
            expectedGraduationDate: new FormField(
                this.application.expectedGraduationDate,
                RequiredFieldValidator
            ),
            privatePartyId: new FormField(
                this.parent.parent.initApplication?.privatePartyId,
                RequiredFieldValidator
            ),
            acceptPrivacyPolicy: new FormField(
                this.application.acceptPrivacyPolicy,
                RequiredFieldValidator
            )
        });
    };

    onSaveForm = async (): Promise<boolean> => {
        const validation = await this.form.validate();
        if (validation) {
            const { fields } = this.form;
            this.formValues = {
                ...this.formValues,
                birthDate: fields.birthDate.value,
                gender: fields.gender.value,
                schoolName: fields.schoolName.value,
                expectedGraduationDate: !!fields.expectedGraduationDate.value
                    ? (fields.expectedGraduationDate
                          .value as Date).toISOString()
                    : undefined,
                privatePartyId: fields.privatePartyId.value,
                acceptPrivacyPolicy: fields.acceptPrivacyPolicy.value
            };
            return true;
        }
        return false;
    };

    onNext = async () => {
        return this.onSaveForm();
    };

    @computed get isNextDisable(): boolean {
        return (
            this.form.isPristine &&
            !this.userAddresses?.doubleSelectedParty.private
        );
    }

    onSelectAddress = async () => {
        if (!!this.userAddresses) {
            this.form.fields.privatePartyId.value = this.userAddresses.doubleSelectedParty.private;
        }
    };
}

export default StudentForm;
